module.exports = __webpack_public_path__ + "static/media/32n.c26dcf19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/32n.svg
// module id = 175
// module chunks = 0